import "./AboutUs.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TransformYourSpace from "./sections/TransformYourSpace";
import AboutTheMaster from "./sections/AboutTheMaster";
import AboutCompany from "./sections/AboutCompany";
import HowItWorks from "./sections/HowItWorks";
import BeginYourExperience from "./sections/BeginYourExperience";
import Footer from "@/reusable_sections/Footer";
import OurJourneyTimeline from "./sections/OurJourneyTimeline";
export default function AboutUsPage() {
  return <div>
      <MainNavigation />
      <TransformYourSpace />
      <AboutCompany />
      <OurJourneyTimeline />
      <AboutTheMaster />
      <HowItWorks />
      <BeginYourExperience />
      <Footer />
    </div>;
}